import { __assign, __rest } from "tslib";
import React from 'react';
import Button from './Button';
import StyledProgress from './StyledProgress';
export default function LoadingButton(props) {
    var _a = props.thickness, thickness = _a === void 0 ? 2 : _a, color = props.color, loading = props.loading, disabled = props.disabled, children = props.children, other = __rest(props, ["thickness", "color", "loading", "disabled", "children"]);
    return (React.createElement(Button, __assign({ color: color, disabled: loading || disabled }, other),
        children,
        loading && (React.createElement(StyledProgress, { size: 20, thickness: thickness, color: color }))));
}
//# sourceMappingURL=LoadingButton.js.map